export const heading = [
  { id: 1, label: 'Bank/Cash Book' },
  // { id: 2, label: 'Bank Book' },
  { id: 3, label: 'All Ledgers' },
  { id: 4, label: 'Day Book' },
  { id: 5, label: 'TDS/TCS Reports' },
  { id: 6, label: 'GST Reports' },
  { id: 7, label: 'Outstanding' },
  // { id: 8, label: 'Receivables' },
  { id: 9, label: 'Item &  Inventory' },
];
export const Outstandingdata = [
  { accountsid: '010', accountname: 'Receivable' },
  { accountsid: '020', accountname: 'Receivable Ageing' },
  { accountsid: '030', accountname: 'Payable' },
  { accountsid: '040', accountname: 'Payable Ageing' },
];
export const inventoryDropDown = [
  { accountsid: '101', accountname: 'Stock & Item wise P&L' },
  { accountsid: '102', accountname: 'Stock Ledger' },
];

// export const tdstcsdata = [
//   { accountsid: 1, accountname: "TDS Report" },
//   { accountsid: 2, accountname: "TCS Report" },
// ];
export const tdstcsdata = [
  { accountsid: '01', accountname: 'TCS Payable Report' },
  { accountsid: '02', accountname: 'TCS Receivable Report' },
  { accountsid: '03', accountname: 'TDS Payable Report' },
  { accountsid: '04', accountname: 'TDS Receivable Report' },
];
export const voucherTypes = [
  { label: 'Bank Payment', value: 'BankPayment' },
  { label: 'Bank Receipt', value: 'BankReceipt' },
  { label: 'Cash Payment', value: 'CashPayment' },
  { label: 'Cash Receipt', value: 'CashReceipt' },
  { label: 'Credit Note', value: 'CreditNote' },
  { label: 'Debit Note', value: 'DebitNote' },
  { label: 'Journal', value: 'ManualJournal' },
  { label: 'POS Invoice', value: 'PosInvoice' },
  { label: 'Purchase Invoice', value: 'PurchaseInvoice' },
  { label: 'Sales Invoice', value: 'SalesInvoice' },
];
export const headCell = [
  {
    field: 'enteredtimestamp',
    id: 'Date',
    label: 'Date',
    width: '100px',
    align: 'left',
    type: 'date',
    enableSort: true,
  },

  {
    field: 'oppositeaccountname',
    id: 'Account',
    label: 'Account',
    width: '150px',
    align: 'left',
    type: 'text',
    enableSort: true,
  },
  {
    field: 'vouchertype',
    id: 'VoucherType',
    label: 'Voucher Type',
    width: '100px',
    align: 'left',
    type: 'select',
    options: voucherTypes,
    enableSort: true,
  },
  {
    field: 'vouchernumber',
    id: 'VoucherNumber',
    label: 'Voucher No.',
    width: '60px',
    align: 'left',
    type: 'text',
    enableSort: true,
  },

  {
    field: 'totaldebitamount',
    id: 'debit',
    label: 'Debit (₹)',
    // width: '60px',
    align: 'right',
    type: 'slider',
    enableSort: true,
  },
  {
    field: 'totalcreditamount',
    id: 'credit',
    label: 'Credit (₹)',
    // width: '60px',
    align: 'right',
    type: 'slider',
    enableSort: true,
  },
  {
    field: 'balance',
    id: 'Balance',
    label: 'Balance (₹)',
    // width: '100px',
    align: 'right',
    enableSort: false,
  },
  {
    field: 'setoff',
    id: 'setoff',
    label: 'Set Off',
    width: '20px',
    align: 'right',
    // type: 'slider',
    enableSort: false,
  },
  {
    field: 'setoffbalance',
    id: 'setoffbalance',
    label: 'Pending to Setoff(₹)',
    // width: '100px',
    align: 'right',
    enableSort: false,
  },
  {
    field: 'setoffremarks',
    id: 'setoffremarks',
    label: 'Set off remarks',
    // width: '100px',
    align: 'left',
    enableSort: false,
  },
  {
    field: 'comments',
    id: 'remarks',
    label: 'Remarks',
    // width: '300px',
    align: 'left',
    type: 'text',
    enableSort: true,
  },
];

export const dayBookHeadCells = [
  { id: '1', label: 'Date', align: 'left', type: 'date', enableSort: true, width: '40px', field: 'enteredtimestamp' },
  { id: '2', label: 'Voucher Number', align: 'left', type: 'text', width: '140px', enableSort: true, field: 'vouchernumber' },
  {
    id: '3',
    label: 'Voucher Type',
    align: 'left',
    type: 'select',
    options: voucherTypes,
    enableSort: true,
    width: '140px',
    field: 'transactiontype',
  },
  { id: '4', label: 'Accounts', align: 'left', type: 'text', enableSort: false, width: '100px', field: 'accountname' },
  { id: '5', label: 'Debit Amount (₹)', align: 'right', type: 'slider', enableSort: true, width: '100px', field: 'totaldebitamount' },
  { id: '6', label: 'Credit Amount (₹)', align: 'right', type: 'slider', enableSort: true, width: '100px', field: 'totalcreditamount' },
  { id: '7', label: 'Remarks', align: 'left', type: 'text', enableSort: true, width: '100px', field: 'comments' },
];

export const receivableHeadCells = [
  { id: '1', label: 'Invoice Number' },
  { id: '2', label: 'Date' },
  { id: '3', label: 'Customer Display Name' },
  { id: '4', label: 'Invoice Amount' },
  { id: '5', label: 'Received Amount' },
  { id: '6', label: 'Balance Outstanding' },
  { id: '7', label: 'credit Period' },
  { id: '8', label: 'Due Date' },
  { id: '9', label: 'Days to Due' },
];

export const GSTHeadCells = [
  { accountsid: '001', accountname: 'GSTR 1' },
  { accountsid: '002', accountname: 'GSTR 2' },
  { accountsid: '003', accountname: 'GSTR 3B' },
  { accountsid: '004', accountname: 'Eway Bill List' },
];

export const months = [
  { label: 'April', id: 4 },
  { label: 'May', id: 5 },
  { label: 'June', id: 6 },
  { label: 'July', id: 7 },
  { label: 'August', id: 8 },
  { label: 'September', id: 9 },
  { label: 'October', id: 10 },
  { label: 'November', id: 11 },
  { label: 'December', id: 12 },
  { label: 'January', id: 1 },
  { label: 'February', id: 2 },
  { label: 'March', id: 3 },
];

export const shortMonth = [
  { label: 'Apr', id: 4 },
  { label: 'May', id: 5 },
  { label: 'Jun', id: 6 },
  { label: 'Jul', id: 7 },
  { label: 'Aug', id: 8 },
  { label: 'Sep', id: 9 },
  { label: 'Oct', id: 10 },
  { label: 'Nov', id: 11 },
  { label: 'Dec', id: 12 },
  { label: 'Jan', id: 1 },
  { label: 'Feb', id: 2 },
  { label: 'Mar', id: 3 },
];

export const quarter = [
  { label: 'April to June ', id: 'Q1' },
  { label: 'July to September ', id: 'Q2' },
  { label: 'October to December ', id: 'Q3' },
  { label: 'January to March ', id: 'Q4' },
];

export const shortQuarter = [
  { label: 'Apr to Jun', id: 'Q1' },
  { label: 'Jul to Sep', id: 'Q2' },
  { label: 'Oct to Dec', id: 'Q3' },
  { label: 'Jan to Mar', id: 'Q4' },
];
export const half = [
  { label: 'April to September ', id: 'H1' },
  { label: 'October to March ', id: 'H2' },
];

export const shortHalf = [
  { label: 'Apr to Sep', id: 'H1' },
  { label: 'Oct to Mar', id: 'H2' },
];

export const periodDropdown = [
  { label: 'Today', id: 'day', menu: false },
  { label: 'Monthly', id: 'month', menu: true },
  { label: 'Quarterly', id: 'quarter', menu: true },
  { label: 'Half yearly', id: 'half', menu: true },
  { label: 'Yearly', id: 'year', menu: false },
  { label: 'Custom Date', id: 'date', menu: false },
];

export const asOnPeriodDropdown = [
  { label: 'Till Today', id: 'day', menu: false },
  { label: 'Month End', id: 'month', menu: true },
  { label: 'Quarter End', id: 'quarter', menu: true },
  { label: 'Half End', id: 'half', menu: true },
  { label: 'Financial Year End', id: 'year', menu: true },
  { label: 'Custom Date', id: 'date', menu: false },
];
